var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#FDE0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_583_21828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5H7.505M10.5 10.5H10.505M11 7L7 11M11.9506 5.49925C12.0535 5.74827 12.2512 5.9462 12.5 6.04954L13.3726 6.41099C13.6216 6.51414 13.8195 6.712 13.9226 6.96103C14.0258 7.21006 14.0258 7.48987 13.9226 7.7389L13.5615 8.6109C13.4583 8.86004 13.4581 9.14014 13.5618 9.38916L13.9223 10.2609C13.9735 10.3842 13.9998 10.5165 13.9998 10.65C13.9998 10.7835 13.9736 10.9157 13.9225 11.0391C13.8714 11.1624 13.7965 11.2745 13.702 11.3689C13.6076 11.4633 13.4955 11.5382 13.3721 11.5892L12.5002 11.9504C12.2512 12.0534 12.0532 12.251 11.9499 12.4999L11.5885 13.3725C11.4853 13.6215 11.2875 13.8194 11.0385 13.9226C10.7894 14.0257 10.5096 14.0257 10.2606 13.9226L9.38864 13.5614C9.13961 13.4585 8.85991 13.4587 8.61104 13.5619L7.73845 13.9229C7.48956 14.0258 7.21001 14.0257 6.96118 13.9226C6.71236 13.8196 6.51463 13.6219 6.41141 13.3732L6.04986 12.5003C5.9469 12.2513 5.74927 12.0534 5.50042 11.95L4.62783 11.5886C4.37892 11.4855 4.18113 11.2877 4.07794 11.0388C3.97475 10.7899 3.97461 10.5103 4.07755 10.2613L4.43873 9.38928C4.54163 9.14024 4.54142 8.86053 4.43815 8.61164L4.07749 7.73839C4.02635 7.61505 4.00002 7.48284 4 7.34932C3.99998 7.21579 4.02627 7.08358 4.07736 6.96022C4.12846 6.83686 4.20336 6.72478 4.29778 6.63038C4.39221 6.53598 4.50431 6.46111 4.62768 6.41005L5.49965 6.04886C5.74844 5.94599 5.94624 5.7486 6.04965 5.50003L6.41109 4.6274C6.51424 4.37837 6.71209 4.18052 6.96111 4.07736C7.21013 3.97421 7.48993 3.97421 7.73896 4.07736L8.61092 4.43856C8.85995 4.54146 9.13965 4.54125 9.38853 4.43797L10.2615 4.07792C10.5105 3.97483 10.7902 3.97485 11.0392 4.07798C11.2882 4.18112 11.486 4.37891 11.5892 4.62788L11.9507 5.50076L11.9506 5.49925ZM7.75 7.5C7.75 7.63807 7.63807 7.75 7.5 7.75C7.36193 7.75 7.25 7.63807 7.25 7.5C7.25 7.36193 7.36193 7.25 7.5 7.25C7.63807 7.25 7.75 7.36193 7.75 7.5ZM10.75 10.5C10.75 10.6381 10.6381 10.75 10.5 10.75C10.3619 10.75 10.25 10.6381 10.25 10.5C10.25 10.3619 10.3619 10.25 10.5 10.25C10.6381 10.25 10.75 10.3619 10.75 10.5Z",
    stroke: "url(#paint0_linear_583_21828)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_583_21828",
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_583_21828"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_583_21828",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_583_21828",
    x1: 4,
    y1: 4,
    x2: 14.1708,
    y2: 4.17682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.f9d9676cdf94694501ad4a9672ed0db0.svg";
export { ForwardRef as ReactComponent };